// Angular
import '@angular/platform-browser';
import '@angular/platform-browser-dynamic';
import '@angular/core';
import '@angular/common';
import '@angular/http';
import '@angular/router';

// RxJS
import 'rxjs';

// Other vendors for example jQuery, Lodash or Bootstrap
// You can import js, ts, css, sass, ...
import 'primeng/resources/primeng.min.css';
import 'primeng/resources/themes/bootstrap/theme.css';
import 'font-awesome/css/font-awesome.css';
import "nouislider/distribute/nouislider.min.css";



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/vendor.ts